import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
// import firebase from "firebase/compat/app";
import logo from "../assets/the-konkan-route-logo.webp";
import "./styles/Dashboard.css";

const Dashboard = ({ cartCount, productsData, setCart }) => {
  const [categories, setCategories] = useState([]);
  const [sideBar, setSideBar] = useState(false);
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
    setSideBar(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (productsData) {
          const uniqueCategory = []; // Temporary array to store unique origins
          productsData.forEach((product) => {
            if (!uniqueCategory.includes(product.Category)) {
              uniqueCategory.push(product.Category);
            }
          });

          setCategories(uniqueCategory); // Update state with the unique origins
        }
      } catch (error) {
        console.error("Error fetching origins:", error);
      }
    };

    fetchData();
  }, [productsData, setCategories]);


  return (
    <div className="dashboardContainer">
      <nav className="dashboardNavbar">
        <img src={logo} alt="logo" className="navbarLogo" onClick={() => handleNavigation("/")} />
        <div className="dashboardContent">
          <div className="rightbutton">
            <button className="navbutton" onClick={() => handleNavigation("/Cart")}>
              <div className="cart-container" style={{ transform: "translateY(5px)" }}>
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#FEB800" width="40px" height="40px">
                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                  <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <path d="M2 3L2.26491 3.0883C3.58495 3.52832 4.24497 3.74832 4.62248 4.2721C5 4.79587 5 5.49159 5 6.88304V9.5C5 12.3284 5 13.7426 5.87868 14.6213C6.75736 15.5 8.17157 15.5 11 15.5H19" stroke="#24370A" strokeWidth="1.5" strokeLinecap="round"></path>
                    <path opacity="0.5" d="M7.5 18C8.32843 18 9 18.6716 9 19.5C9 20.3284 8.32843 21 7.5 21C6.67157 21 6 20.3284 6 19.5C6 18.6716 6.67157 18 7.5 18Z" stroke="#24370A" strokeWidth="1.5"></path>
                    <path opacity="0.5" d="M16.5 18.0001C17.3284 18.0001 18 18.6716 18 19.5001C18 20.3285 17.3284 21.0001 16.5 21.0001C15.6716 21.0001 15 20.3285 15 19.5001C15 18.6716 15.6716 18.0001 16.5 18.0001Z" stroke="#24370A" strokeWidth="1.5"></path>
                    <path d="M5 6H16.4504C18.5054 6 19.5328 6 19.9775 6.67426C20.4221 7.34853 20.0173 8.29294 19.2078 10.1818L18.7792 11.1818C18.4013 12.0636 18.2123 12.5045 17.8366 12.7523C17.4609 13 16.9812 13 16.0218 13H5" stroke="#24370A" strokeWidth="1.5"></path>
                  </g>
                </svg>
                {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
              </div>
            </button>
            <button className="profile-navbutton" onClick={() => handleNavigation("/Profile")}>
              <svg fill="#24370A" height="40px" width="40px" version="1.1" id="Layer_1"
                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 402.161 402.161" >
                <g id="SVGRepo_iconCarrier">
                  <g>
                    <path d="M201.08,49.778c-38.794,0-70.355,31.561-70.355,70.355c0,18.828,7.425,40.193,19.862,57.151 c14.067,19.181,32,29.745,50.493,29.745c18.494,0,36.426-10.563,50.494-29.745c12.437-16.958,19.862-38.323,19.862-57.151 C271.436,81.339,239.874,49.778,201.08,49.778z M201.08,192.029c-13.396,0-27.391-8.607-38.397-23.616 c-10.46-14.262-16.958-32.762-16.958-48.28c0-30.523,24.832-55.355,55.355-55.355s55.355,24.832,55.355,55.355 C256.436,151.824,230.372,192.029,201.08,192.029z"></path>
                    <path d="M201.08,0C109.387,0,34.788,74.598,34.788,166.292c0,91.693,74.598,166.292,166.292,166.292 s166.292-74.598,166.292-166.292C367.372,74.598,292.773,0,201.08,0z M201.08,317.584c-30.099-0.001-58.171-8.839-81.763-24.052 c0.82-22.969,11.218-44.503,28.824-59.454c6.996-5.941,17.212-6.59,25.422-1.615c8.868,5.374,18.127,8.099,27.52,8.099 c9.391,0,18.647-2.724,27.511-8.095c8.201-4.97,18.39-4.345,25.353,1.555c17.619,14.93,28.076,36.526,28.895,59.512 C259.25,308.746,231.178,317.584,201.08,317.584z M296.981,283.218c-3.239-23.483-15.011-45.111-33.337-60.64 c-11.89-10.074-29.1-11.256-42.824-2.939c-12.974,7.861-26.506,7.86-39.483-0.004c-13.74-8.327-30.981-7.116-42.906,3.01 c-18.31,15.549-30.035,37.115-33.265,60.563c-33.789-27.77-55.378-69.868-55.378-116.915C49.788,82.869,117.658,15,201.08,15 c83.423,0,151.292,67.869,151.292,151.292C352.372,213.345,330.778,255.448,296.981,283.218z"></path>
                    <path d="M302.806,352.372H99.354c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5h203.452c4.142,0,7.5-3.358,7.5-7.5 C310.307,355.73,306.948,352.372,302.806,352.372z"></path>
                    <path d="M302.806,387.161H99.354c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5h203.452c4.142,0,7.5-3.358,7.5-7.5 C310.307,390.519,306.948,387.161,302.806,387.161z"></path>
                  </g>
                </g>
              </svg>
            </button>
            <div
              className="sidebarControl"
              onClick={() => {
                if (sideBar) {
                  setSideBar(false);
                } else {
                  setSideBar(true);
                }
              }}
            >
              <svg width="50" height="50" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path fill="none" stroke="#23370A" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </div>
          </div>
          <div className="leftbutton">
            <button className="navbutton" onClick={() => handleNavigation("/")}>
              Home
            </button>
            <button
              className="navbutton" onClick={() => handleNavigation("/Collections/Destination")}>
              Destination
            </button>
            <button className="navbutton" onClick={() => handleNavigation("/ContactUs")}>
              Contact us
            </button>
          </div>
        </div>

      </nav>

      <div className="outletContainer">
        <Outlet />
      </div>
      {/* Sidebar */}
      <div className="sidebarContent">
        <div className={sideBar ? "sidebar sidebarOpen" : "sidebar sidebarClosed"}>
          <button className="sidebarButton" onClick={() => handleNavigation("/")}>
            Home
          </button>
          <button
            className="sidebarButton" onClick={() => handleNavigation("/Collections/Combos")}>
            Combos
          </button>
          <button className="sidebarButton" onClick={() => handleNavigation(`/Collections/Destination`)}>
            Destination
          </button>
          <div className="sidebarDropdown">
            <button className="sidebarButton">
              Category
            </button>
            <div className="dropdownContent">
              {categories.map((category) => (
                <button
                  key={category}
                  className="dropdownItem"
                  onClick={() => {
                    handleNavigation(`/Collections/Category/${category}`);
                    setSideBar(false); // Close sidebar after selection
                  }}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
          <button className="sidebarButton" onClick={() => handleNavigation("/ContactUs")}>
            Contact us
          </button>
          <button className="sidebarButton" onClick={() => handleNavigation("/Profile")}>
            Profile
          </button>
          <button className="sidebarButton" onClick={() => handleNavigation("/Orders")}>
            Orders
          </button>
          <button className="sidebarButton" onClick={() => handleNavigation("/Cart")}>
            Cart
          </button>
          {/* <button className="sidebarButton" onClick={() => {
            // Track sign out event
            window.gtag("event", "admin_sign_out", {
              event_category: "email/password",
              event_label: "signed out",
          });
            // Handle sign out logic here
            firebase.auth().signOut();
            setSideBar(false);  // Close sidebar after sign out
            setCart([]);
            navigate("/");
          }}>
            Sign Out
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
